import React from 'react'
import { Feed } from './Feed'

export const Home = ({posts}) => {
  return (
   <main className='Home'>
    {posts.length ? (<Feed posts={posts}/>
    ):(
      <p className="noPostsMessage" style={{marginTop:"2rem"}}>
        NO posts to display
      </p>
    )}
   </main>
  )
}

